import { apiRequest } from "../api";

export const getReviews = (endpoint: string) => apiRequest(endpoint, "GET");
export const deleteReview = (id: string) => apiRequest(`/reviews/${id}`, "DELETE");
